import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { UserSettingsDialogComponent } from './user-settings-dialog/user-settings-dialog.component';
import { User } from './user-settings.model';
import { UserSettingsService } from './user-settings.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class UserSettingsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private spinnerService: SpinnerService,
    private userService: UserSettingsService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
  ) { }

  searchForm: UntypedFormGroup;

  displayedColumns: string[] = [
    'id',
    'Username',
    'Firstname',
    'Lastname',
    'Email',
    'roles',
    'actions',
  ];
  tabledata: User[] = [];
  dataSource = new MatTableDataSource();
  dialogConfig = new MatDialogConfig();

  ngOnInit(): void {
    this.fetchData();

    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  fetchData(): void {
    this.spinnerService.startSpinner();
    this.userService.fetchUsers().subscribe(
      (data: User[]) => {
        this.tabledata = data;

        this.dataSource = new MatTableDataSource(this.tabledata);
        this.dataSource.paginator = this.paginator;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  deleteColumn(user: User, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.spinnerService.startSpinner();
        this.userService.deleteUser(user.id).subscribe(
          () => {
            this.fetchData();
            this.snackbarService.openSuccess();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  openEdit(data: any, rowIndex?: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.width = '500px';

    const dialogRef = this.dialog.open(
      UserSettingsDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data: User) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  submit(user: User): void {
    this.spinnerService.startSpinner();
    // wenn id vorhanden: update
    if (user.id) {
      this.userService.putUser(user).subscribe(
        (data: User) => {
          for (let i = 0; i < this.tabledata.length; i++) {
            if (this.tabledata[i].id == data.id) {
              this.tabledata[i] = data;
              this.spinnerService.stopSpinner();
              this.snackbarService.openSuccess();
            }
          }

          this.refreshTable(this.tabledata);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    } else {
      // wenn keine id vorhanden: create
      this.userService.postUser(user).subscribe(
        (data: User) => {
          this.tabledata.push(data);
          this.refreshTable(this.tabledata);
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    }
  }

  openAdd(): void {
    const dialogRef = this.dialog.open(UserSettingsDialogComponent, {
      width: '500px'
    });
    dialogRef.afterClosed().subscribe((data: User) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  refreshTable(tabledata: User[]): void {
    this.dataSource = new MatTableDataSource(tabledata);
    this.dataSource.paginator = this.paginator;
  }
}
